import { useEffect, useState } from "react";
import { PiggyBank } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Lesson earnings recorded before the learner's accounts opened. They are
 * held server-side and deposit automatically once Checking becomes active.
 */
const HeldEarningsCard = () => {
  const [total, setTotal] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let active = true;
    (async () => {
      const { data } = await supabase
        .from("pending_lesson_earnings")
        .select("amount")
        .is("released_at", null);
      if (!active || !data) return;
      setCount(data.length);
      setTotal(data.reduce((sum, row) => sum + Number(row.amount ?? 0), 0));
    })();
    return () => {
      active = false;
    };
  }, []);

  if (total <= 0) return null;

  return (
    <Card className="border-primary/30 bg-primary/5">
      <CardContent className="flex items-center gap-3 p-4">
        <PiggyBank className="h-5 w-5 text-primary" />
        <div>
          <p className="font-semibold">${total} in held earnings</p>
          <p className="text-sm text-muted-foreground">
            From {count} lesson{count === 1 ? "" : "s"} completed before your accounts opened. It deposits
            automatically as soon as Checking is active.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default HeldEarningsCard;
